/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './operation-theatre.reducer';

export const OperationTheatreDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const operationTheatreEntity = useAppSelector(state => state.operationTheatre.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="operationTheatreDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.operationTheatre.detail.title">OperationTheatre</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.operationTheatre.id">Id</Translate>
            </span>
          </dt>
          <dd>{operationTheatreEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.operationTheatre.name">Name</Translate>
            </span>
          </dt>
          <dd>{operationTheatreEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.operationTheatre.description">Description</Translate>
            </span>
          </dt>
          <dd>{operationTheatreEntity.description}</dd>
          <dt>
            <span id="startTime">
              <Translate contentKey="tinyMedicRestApp.operationTheatre.startTime">Start Time</Translate>
            </span>
          </dt>
          <dd>{operationTheatreEntity.startTime}</dd>
          <dt>
            <span id="endTime">
              <Translate contentKey="tinyMedicRestApp.operationTheatre.endTime">End Time</Translate>
            </span>
          </dt>
          <dd>{operationTheatreEntity.endTime}</dd>
          <dt>
            <span id="dateSuspended">
              <Translate contentKey="tinyMedicRestApp.operationTheatre.dateSuspended">Date Suspended</Translate>
            </span>
          </dt>
          <dd>{operationTheatreEntity.dateSuspended}</dd>
          <dt>
            <span id="reasonSuspended">
              <Translate contentKey="tinyMedicRestApp.operationTheatre.reasonSuspended">Reason Suspended</Translate>
            </span>
          </dt>
          <dd>{operationTheatreEntity.reasonSuspended}</dd>
          <dt>
            <span id="nextMaintenanceDate">
              <Translate contentKey="tinyMedicRestApp.operationTheatre.nextMaintenanceDate">Next Maintenance Date</Translate>
            </span>
          </dt>
          <dd>{operationTheatreEntity.nextMaintenanceDate}</dd>
          <dt>
            <span id="lastMaintenanceDate">
              <Translate contentKey="tinyMedicRestApp.operationTheatre.lastMaintenanceDate">Last Maintenance Date</Translate>
            </span>
          </dt>
          <dd>{operationTheatreEntity.lastMaintenanceDate}</dd>
          <dt>
            <span id="suspended">
              <Translate contentKey="tinyMedicRestApp.operationTheatre.suspended">Suspended</Translate>
            </span>
          </dt>
          <dd>{operationTheatreEntity.suspended ? 'true' : 'false'}</dd>
          <dt>
            <span id="underMaintainance">
              <Translate contentKey="tinyMedicRestApp.operationTheatre.underMaintainance">Under Maintainance</Translate>
            </span>
          </dt>
          <dd>{operationTheatreEntity.underMaintainance ? 'true' : 'false'}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.operationTheatre.active">Active</Translate>
            </span>
          </dt>
          <dd>{operationTheatreEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.operationTheatre.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{operationTheatreEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.operationTheatre.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{operationTheatreEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.operationTheatre.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{operationTheatreEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.operationTheatre.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{operationTheatreEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.operationTheatre.hospital">Hospital</Translate>
          </dt>
          <dd>{operationTheatreEntity.hospital ? operationTheatreEntity.hospital.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.operationTheatre.addedBy">Added By</Translate>
          </dt>
          <dd>{operationTheatreEntity.addedBy ? operationTheatreEntity.addedBy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.operationTheatre.modifiedBy">Modified By</Translate>
          </dt>
          <dd>{operationTheatreEntity.modifiedBy ? operationTheatreEntity.modifiedBy.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/operation-theatre" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/operation-theatre/${operationTheatreEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default OperationTheatreDetail;
